import axiosClient, { axiosClientAdmin } from "@/lib/auth"
import { GetFetchSiteSecondaryDevicesMonitoringData, GetFetchSiteSecondaryDevicesMonitoringResponse } from "../types.gen"
import { UseQueryOptions } from "@tanstack/react-query"

export type FetchSiteDevicesInput = GetFetchSiteSecondaryDevicesMonitoringData["path"]
export type FetchSiteDevicesResponse = GetFetchSiteSecondaryDevicesMonitoringResponse

const fetchSiteDevices = async ({ projectId }: FetchSiteDevicesInput) => {
  const { data } = await axiosClientAdmin
    .get<FetchSiteDevicesResponse>(`monitoring/site/${projectId}/devices`)

  return data
}

const fetchSiteDevicesMonitoring = async ({ projectId, companyId }: FetchSiteDevicesInput) => {
  const { data } = await axiosClient
    .get<FetchSiteDevicesResponse>(`/company/${companyId}/project/${projectId}/Monitoring/devices`)

  return data
}

export const FetchSiteDevicesQuery = (input: FetchSiteDevicesInput) => {
  return {
    queryKey: ['siteDevices', input],
    queryFn: () => fetchSiteDevices(input)
  } satisfies UseQueryOptions
}

export const FetchSiteDevicesMonitoringQuery = (input: FetchSiteDevicesInput) => {
  return {
    queryKey: ['siteDevicesMonitoring', input],
    queryFn: () => fetchSiteDevicesMonitoring(input)
  } satisfies UseQueryOptions
}